import { useState, type ChangeEvent } from 'react';
import { FileText, Type } from 'lucide-react';
import type { Idea, NuevaIdeaDraft } from '../../types';

// Mismo tope que valida el servidor en sync (IDEA_NOTAS_MAX).
const NOTAS_MAX = 10_000;

interface Props {
  editando: Idea | null;
  onGuardar: (draft: NuevaIdeaDraft) => void;
  onCancelar: () => void;
}

export function FormularioIdea({ editando, onGuardar, onCancelar }: Props) {
  const [titulo, setTitulo] = useState(editando?.titulo ?? '');
  const [notas, setNotas] = useState(editando?.notas ?? '');

  const guardar = () => {
    if (!titulo.trim()) {
      alert('Por favor escribe un título');
      return;
    }
    onGuardar({ titulo: titulo.trim(), notas });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        {editando ? '✏️ Editar Idea' : 'Nueva Idea'}
      </h2>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Type size={16} className="inline mr-1" />
            Título *
          </label>
          <input
            type="text"
            value={titulo}
            maxLength={300}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setTitulo(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="¿Qué se te ocurrió?"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FileText size={16} className="inline mr-1" />
            Anotaciones
          </label>
          <textarea
            value={notas}
            maxLength={NOTAS_MAX}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setNotas(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent resize-y"
            rows={12}
            placeholder="Desarrolla la idea: detalles, pasos, referencias..."
          />
          <p className="text-xs text-gray-400 text-right mt-1">
            {notas.length.toLocaleString('es-MX')} / {NOTAS_MAX.toLocaleString('es-MX')}
          </p>
        </div>
      </div>
      <div className="flex gap-3 mt-6">
        <button
          onClick={guardar}
          className="flex-1 bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {editando ? 'Guardar Cambios' : 'Guardar Idea'}
        </button>
        <button
          onClick={onCancelar}
          className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
